import { useState } from 'react';
import styles from './LessonRun.module.scss';
import Modal from 'src/components/modal/Modal';
import Button from 'src/components/button/Button';
import './customStyle.css';
import type { MenuProps } from 'antd';
import { Dropdown } from 'antd';
import { StudyPlanContentFragment } from '@src/api/graphql-codegen';
import IconOutline from '@src/assets/icons/outline.svg?react';
import IconHoverOutline from '@src/assets/icons/hover_outline.svg?react';

type Props = {
  open: boolean;
  state: number;
  studyPlansForSelectLesson: StudyPlanContentFragment[];
  onClose: () => void;
  onContinueWithYou: (studyPlan: StudyPlanContentFragment) => void;
  onContinueWithChild: (studyPlan: StudyPlanContentFragment) => void;
};

function LessonRunModal(props: Props) {
  const { open, state, studyPlansForSelectLesson, onClose, onContinueWithYou, onContinueWithChild } = props;

  const [isYourTipHovered, setIsYourTipHovered] = useState(false);
  const [isChildTipHovered, setIsChildTipHovered] = useState(false);
  const [isSemicircleHovered, setIsSemicircleHovered] = useState(false);

  const handleCancel = () => {
    onClose();
  }

  const items: MenuProps['items'] = [{
    key: '1',
    label: (
      (studyPlansForSelectLesson.length > 0) && <div className={styles.studyPlanMenuitem} onClick={() => {} }>
        <div>
          {'Select a Study Plan'}
        </div>
        {<div className={styles.studyNames} style={{display: studyPlansForSelectLesson.length > 0 ? 'flex': 'none'}}>
        {studyPlansForSelectLesson.map((item, i) => {
          return (
            <div key={i} className={styles.addItem} style={{background: `${item.darkColor}`}} onClick={() => onContinueWithChild(item)}>
              <div className={styles.addTitle}>{item.name.substring(0, 2).toLocaleUpperCase()}</div>
            </div>
          )})}
        </div>}
      </div>
    ),
  }];

  const newItems: MenuProps['items'] = [{
    key: '1',
    label: (
      (studyPlansForSelectLesson.length > 0) && <div className={styles.studyPlanMenuitem} onClick={() => {} }>
        <div>
          {'Select a Study Plan'}
        </div>
        {<div className={styles.studyNames} style={{display: studyPlansForSelectLesson.length > 0 ? 'flex': 'none'}}>
        {studyPlansForSelectLesson.map((item, i) => {
          return (
            <div key={i} className={styles.addItem} style={{background: `${item.darkColor}`}} onClick={() => onContinueWithYou(item)}>
              <div className={styles.addTitle}>{item.name.substring(0, 2).toLocaleUpperCase()}</div>
            </div>
          )})}
        </div>}
      </div>
    ),
  }];

  return (
    <Modal global={false} open={open} onClose={onClose} closeButton={false} className={styles.wrapper}>
      <div>
        {studyPlansForSelectLesson.length === 1 ? <>
          <div className={styles.hoverSemiCircleTipView} style={{display: isSemicircleHovered ? "block" : "none"}}>
            <div className={styles.hoverTipDetail}>{studyPlansForSelectLesson[0].name}</div>
          </div>
          <div className={styles.semicircle} onMouseOver={() => setIsSemicircleHovered(true)} onMouseLeave={() => setIsSemicircleHovered(false)}>
            <div className={styles.avatar} style={{background: `${studyPlansForSelectLesson[0].darkColor}`}}>
              <div className={styles.avatarTitle}>{studyPlansForSelectLesson[0].name.substring(0, 2).toLocaleUpperCase()}</div>
            </div>
          </div></> : null}
        <div className={`${styles.header} ${studyPlansForSelectLesson.length === 1 ? styles.lowerHeader : ''}` }>
          <div className={styles.title}>How will this lesson be run?</div>
          <div className={styles.normalText}>Will {studyPlansForSelectLesson.length === 1 ? studyPlansForSelectLesson[0].name : 'your child'} be studying:</div>
        </div>
        <div className={styles.content}>
          <div className={styles.selectView}>
            {state > 1 && <div className={styles.hoverYouTipView} style={{display: isYourTipHovered ? "block" : "none"}}>
              <div className={styles.hoverTipDetail}>{'Use this option if you are going to sit next to your child while they study.'}</div>
            </div>}
            <div className={`${styles.selectOptionView} ${state > 1 ? styles.selectOptionViewPadding : ''} ${isYourTipHovered ? styles.selectOptionViewHover : ''}`}>
              {state > 1 && <div className={styles.iconView}>
                <div className={styles.circleView} onMouseOver={() => setIsYourTipHovered(true)} onMouseLeave={() => setIsYourTipHovered(false)}>
                  <div className={styles.outlineIcon}>
                    <IconOutline />
                  </div>
                  <div className={styles.hoverOutlineIcon}>
                    <IconHoverOutline />
                  </div>
                </div>
              </div>}
              { studyPlansForSelectLesson.length > 1 ?
                (<Dropdown menu={{ items: newItems }} trigger={["click"]} placement="bottom">
                  <Button size="small" className={styles.selectButton} label={'With You?'}/>
                </Dropdown>) :
                <Button size="small" className={styles.selectButton} onClick={() => onContinueWithYou(studyPlansForSelectLesson[0])} label={'With You?'}/>
              }
              {state === 1 && <span>
                {'Use this option if you are going to sit next to your child while they study.'}
              </span>}
            </div>
            {state > 1 && <div className={styles.hoverChildTipView} style={{display: isChildTipHovered ? "block" : "none"}}>
              <div className={styles.hoverTipDetail}>{'Your child will only have access to the Unit you have allocated them.'}</div>
            </div>}
            <div className={`${styles.selectOptionView} ${state > 1 ? styles.selectOptionViewPadding : ''} ${isChildTipHovered ? styles.selectOptionViewHover : ''}`}>
              {state > 1 && <div className={styles.iconView}>
                <div className={styles.circleView} onMouseOver={() => setIsChildTipHovered(true)} onMouseLeave={() => setIsChildTipHovered(false)}>
                  <div className={styles.outlineIcon}>
                    <IconOutline />
                  </div>
                  <div className={styles.hoverOutlineIcon}>
                    <IconHoverOutline />
                  </div>
                </div>
              </div>}
              { studyPlansForSelectLesson.length > 1 ?
                (<Dropdown menu={{ items }} trigger={["click"]} placement="bottom">
                  <Button size="small" className={styles.selectButton} label={'On Their Own?'}/>
                </Dropdown>) :
                (<Button size="small" className={styles.selectButton} label={'On Their Own?'} onClick={() => onContinueWithChild(studyPlansForSelectLesson[0])}/>)
              }
              {state === 1 && <span>
                {'Your child will only have access to the Unit you have allocated them.'}
              </span>}
            </div>
          </div>
          <div className={styles.action}>
            <Button size="small" className={styles.cancelButton} onClick={handleCancel} label={'Cancel'}/>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default LessonRunModal;
